import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AddcontactComponent } from "./addcontact/addcontact.component";
import { ContactsComponent } from "./contact-list/contacts.component";
import { EditcontactComponent } from "./editcontact/editcontact.component";
import { ContactdetailComponent } from "./contactdetail/contactdetail.component";


const routes: Routes = [
  {
    path: "addcontact",
    component: AddcontactComponent,
  },
  {
    path: "contacts-list",
    component: ContactsComponent,
  },
  {
    path: "editcontact/:id",
    component: EditcontactComponent,
    data: {
      allowedRoles: ["maven", "contacts"],
    },
  },
  {
    path: "contactdetail/:id",
    component: ContactdetailComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ContactsRoutingModule {}
